/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const NestIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="NestIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4 2.00002L4 4.50002C4 6.43302 5.567 8.00002 7.5 8.00002L11.2929 8.00002L8.14645 4.85358L8.85355 4.14647L13.2071 8.50002L8.85355 12.8536L8.14645 12.1465L11.2929 9.00002L7.5 9.00002C5.01472 9.00002 3 6.9853 3 4.50002L3 2.00002L4 2.00002Z"
              fill="currentColor"
            />
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

NestIcon.tags = ['arrow', 'right', 'forward', 'next', 'continuation', 'enter'];

NestIcon.category = 'General Icons';

NestIcon.iconSize = 16;
